import cn from "classnames"

import { Trans, useTranslation } from "@/hooks/useTranslation"
import { Remediation } from "@/icons"
import {
  getValues,
  translationsWithVM
} from "@/pages/TriagePage/components/pages/AdrPage/helpers"
import { Step } from "./Step"
import { TitleStep } from "./TitleStep"
import { getRemediateAndHarden } from "./helpers"

import styles from "./NextStepsTabAdr.module.scss"

import type { Props } from "./NextStepsTabAdr.types"

export const RemediateHardenStep = (props: Props) => {
  const { incident } = props
  const keyPrefix = "triage.adr"
  const { t } = useTranslation("translation", { keyPrefix })
  const data = getRemediateAndHarden(incident)
  const {
    title = "tabs.nextSteps.remediate",
    description = "tabs.nextSteps.remediate"
  } = data
  const stepKeyPrefix = data.stepsPrefix || ""
  const { what } = incident
  const values = getValues({ ...what })
  const attr = { values, t }

  return (
    <div className={cn("i-trans-adr", styles.wrapper)}>
      <Remediation className={cn(styles.icon, styles.iconRemediation)} />
      <TitleStep
        title={t(`${title}.title`)}
        description={translationsWithVM(
          `${description}.description`,
          incident,
          attr
        )}
      />
      {data.steps.map((step) => {
        const prefix = stepKeyPrefix ? `${stepKeyPrefix}.${step}` : step
        const title = translationsWithVM(`${prefix}.title`, incident, attr)
        const desc = translationsWithVM(`${prefix}.description`, incident, attr)

        if (!title) return null

        return (
          <Step key={step} title={title} description={<Trans>{desc}</Trans>} />
        )
      })}
    </div>
  )
}
